import { Component, ChangeDetectorRef } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { XpReportService } from "../../services/xp-report.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { FileService } from "../../services/file.service";

@Component({
  selector: 'page-xp-report-files',
  templateUrl: 'xp-report-files.html',
})
export class XpReportFilesPage {

  public unitId = 0;
  public unitVersionId = 0;
  public country = 'NL';
  public enabled = false;
  public showFooter = false;

  public data: any;
  public files: any = [];
  public unitVersionFiles: any = [
    {
      list_title: 'Manual Husqvarna (English)',
      list_subtitle: 'manual-husqvarna-english.pdf',
      url: 'https://mijninstallatiepas.nl/assets/xprnz/husqvarna-automower-435x.pdf'
    }
  ];

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public modalCtrl: ModalController,
      public changeDetector: ChangeDetectorRef,
      public superTabsCtrl: SuperTabsController,
      public reportService: XpReportService,
      public alertCtrl: AlertController,
      public fileService: FileService,
      public iab: InAppBrowser
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    if(!this.data.files) this.data.files = [];
    this.files = this.data.files;
    if(!this.data.location.units) this.data.location.units = [];
    if(this.data._selected_unit){
      this.enabled = true;
      this.unitVersionId = this.data._selected_unit.unit_version_id;
      this.unitId = this.data._selected_unit.unit_id;
    } else {
      this.enabled = false;
      this.unitVersionId = 0;
      this.unitId = 0;
    }
    this.country = (this.data.customers && this.data.customers.client && this.data.customers.client.country ? this.data.customers.client.country : 'NL');
  }

  ionViewDidEnter() {
    console.log('ReportFilesPage: ionViewDidEnter');
    this.initForm();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportFilesPage: ionViewDidLeave');
    if(this.data._selected_unit){
      this.superTabsCtrl.setColor('reportFilesPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportFilesPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportFilesPage', 'tab_error', 'mainTabs');
      this.data._valid.reportFilesPage = -1;
    }
    this.save();
  }

  addFile(){
    this.fileService.getFile().then((file: any) => {
      file.list_title = file.filename;
      file.list_subtitle = 'Zojuist toegevoegd';
      file.url = file.src;
      this.files.push(file);
    }).catch((error) => {
      this.changeDetector.detectChanges();
      if(error == -1){
        this.alertCtrl.create({
          title: 'Bestand te groot',
          message: 'Dit bestand is te groot. Het bestand mag maximaal ' + this.fileService.maxFileSizeMegaBytes + 'MB groot zijn',
          buttons: ['OK']
        }).present();
      }
    });
  }

  viewFile(file){
    if(file.url){
      this.iab.create(file.url, '_system');
    }
  }

  removeFile(index){
    this.alertCtrl.create({
      title: 'Bestand verwijderen',
      message: 'Weet u zeker dat u dit bestand wilt verwijderen?',
      buttons: [
        {
          text: 'Nee',
          role: 'cancel'
        },
        {
          text: 'Ja',
          handler: () => {
            this.files.splice(index, 1);
          }
        }
      ]
    }).present();
  }

  save(){
    this.data.files = this.files;
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      if (this.data._show_all_tabs) {
        this.superTabsCtrl.slideTo('reportMeasurementPage', 'mainTabs');
      } else {
        this.superTabsCtrl.slideTo('reportSubmitPage', 'mainTabs');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report-files/xp-report-files.ts